'use client';
import { useState } from 'react';
import { sendEmailVerificationLink } from '@/lib/usersApi';
import Button from '@/ui/Button';
import { Row } from '@/ui/primatives';
import { CheckIcon, Cross2Icon } from '@radix-ui/react-icons';
import Spinner from '@/ui/Spinner';
import { colors } from '@/styles';

const EmailVerificationButton: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleClick = async () => {
    setIsLoading(true);
    setError(null);
    setSuccess(null);

    const response = await sendEmailVerificationLink({ redirectPath: '/resend-verification-email' });

    if (response.status === 'success') {
      setSuccess('Verification link sent successfully');
      setIsLoading(false);
    } else {
      setError(response.error?.detail || 'Failed to send verification link');
      setIsLoading(false);
    }
  };

  return (
    <>
      <Row alignItems="center" gap={5}>
        {isLoading && <Spinner size={14} />}
        {success && <CheckIcon style={{ color: colors.semantic.positive.primary }} />}
        {error && <Cross2Icon style={{ color: colors.semantic.negative.primary }} />}
        <Button.Text small className="link-underline" disabled={isLoading} onClick={handleClick}>
          {children || 'Click here to re-send your verification link'}
        </Button.Text>
      </Row>
    </>
  );
};

export default EmailVerificationButton;
